import { RootState } from "../index";
import { NotificationStateSlice } from "./notification.types";

export const getSlice = (state: RootState): NotificationStateSlice => state.notification;
